<template>
  <i class="icon" :class="[icon]" style="color" v-bind="$attrs"></i>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    icon: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: false,
    },
  },
});
</script>

<style lang="scss">
.icon {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icons" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: #767676;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &.close:before {
    content: "\e907";
  }
  &.x-bold {
    content: "\e802";
  }
  &.soft-pull:before {
    content: "\e900";
  }
  &.headphones:before {
    content: "\e901";
  }
  &.info:before {
    content: "\e902";
  }
  &.info-green:before {
    content: "\e902";
    color: #008000;
  }
  &.money:before {
    content: "\e903";
  }
  &.people:before {
    content: "\e904";
  }
  &.person:before {
    content: "\e905";
  }
  &.self-select:before {
    content: "\e906";
  }
  &.x-bold:before {
    content: "\e908";
  }
  &.chevron-up:before {
    content: "\e90A";
  }
  &.chevron-down:before {
    content: "\e90B";
  }
}
</style>
